(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ns-hero"] && !Shopify.designMode) return;
  try {
    

(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-ns-sale-campaign]').forEach((campaign) => {
      if (campaign.dataset.expiryBound) return;
      campaign.dataset.expiryBound = 'true';
      const deadline = Number(campaign.dataset.endsAt) * 1000;
      const expire = () => {
        const fallback = campaign.nextElementSibling;
        if (fallback?.matches('template[data-ns-sale-fallback]')) {
          campaign.replaceWith(fallback.content.cloneNode(true));
          fallback.remove();
        }
      };
      const check = () => {
        const remaining = deadline - Date.now();
        if (remaining <= 0) expire();
        else window.setTimeout(check, Math.min(remaining, 86400000));
      };
      check();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
